interface LogoProps {
  size?: number;
  showText?: boolean;
  className?: string;
}

export function Logo({ size = 32, showText = true, className = '' }: LogoProps) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <svg
        width={20}
        height={24}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Ochtopus - InVideo Style Octopus Icon */}

        {/* Ana kafa - organik blob */}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 0.8C5.2 0.8 1.5 4.2 1.5 8.2C1.5 10.5 2.7 12.5 4.5 13.8C4.8 14 4.9 14.4 4.8 14.7C4.6 15.1 4.5 15.5 4.5 16C4.5 16.8 4.9 17.5 5.5 17.9C5.3 18.6 5.5 19.4 6.2 19.4C6.6 19.4 6.9 19.1 7 18.7C7.3 19.1 7.7 19.4 8.2 19.4C8.7 19.4 9.1 19.1 9.3 18.7C9.6 19.1 10 19.4 10.5 19.4C11 19.4 11.4 19.1 11.6 18.7C11.9 19.1 12.3 19.4 12.8 19.4C13.3 19.4 13.7 19.1 13.9 18.7C14.1 19.1 14.5 19.4 15 19.4C15.7 19.4 16.2 18.6 16 17.9C16.6 17.5 17 16.8 17 16C17 15.5 16.9 15.1 16.7 14.7C16.6 14.4 16.7 14 17 13.8C18.8 12.5 20 10.5 20 8.2C20 4.2 16.3 0.8 11.5 0.8C11 0.8 10.5 0.8 10 0.8Z"
          fill="#8B5CF6"
        />

        {/* Sol göz */}
        <circle cx="7.5" cy="7.5" r="1.8" fill="#1a1a1a"/>

        {/* Sağ göz */}
        <circle cx="13.5" cy="7.5" r="1.8" fill="#1a1a1a"/>

        {/* Kabarcık - InVideo style */}
        <circle cx="18" cy="2.5" r="1.8" fill="#8B5CF6"/>
      </svg>
      {showText && (
        <span className="font-bold bg-gradient-to-r from-purple-500 via-violet-500 to-fuchsia-500 bg-clip-text text-transparent" style={{ fontSize: '1rem' }}>
          Ochtopus
        </span>
      )}
    </div>
  );
}
